
import { useState,useEffect } from "react";
import marksentryapi from '../api/marksEntry';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";

import Course from '../components/MarksEntryCoursesCourseCard';
import SelectedImages from '../components/SelectedImages'

function MarksEntry({accessToken,setAccessToken,setRefreshFailed,marksEntrySession,setMarksEntrySession,sessions,levels,semesters,marksEntryLevel,setMarksEntryLevel,marksEntrySem,setMarksEntrySem,marksEntrySub,setMarksEntrySub}) {
    const navigate = useNavigate();
  const [courses,setCourses]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);

  const [images,setImages]=useState([]);
    const [uploadStatus, setUploadStatus]=useState(null);
const [isUploading,setIsUploading]=useState(false);
const [isConfirming,setIsConfirming]=useState(false);

const [isConfirmed,setIsConfirmed]=useState("");
const [messages,setMessages]=useState([]);


   const sessionChanged = async (e) => {
    const session = e.target.value;
    setCourses([]);
    setMarksEntrySession(session);
setUploadStatus(null);
setIsConfirmed("");
  window.scrollTo({ top: 0, behavior: "smooth" });
  // Store current scroll position of <main> in sessionStorage
  const mainElement = document.querySelector("main");
  if (mainElement) {
    sessionStorage.setItem("scrollPositionme", mainElement.scrollTop);
  }
  
  };

  const levelChanged=async(e)=>{
      const level = e.target.value;
    setMarksEntryLevel(level);
  }

    const semesterChanged=async(e)=>{
      const sem = e.target.value;
    setMarksEntrySem(sem);
  }
  
    const subChanged=async(e)=>{
      const sub = e.target.value.toUpperCase();
    setMarksEntrySub(sub);
  }


  
  const handleAddNew=async (e)=>
      {
         e.preventDefault();
         setUploadStatus(null);
         setIsUploading(true);
         
          let formData = new FormData();    //formdata object
          formData.append("session", marksEntrySession);
    
          
    
          Object.values(images).forEach(file=>{
            formData.append("images", file);
          });
          const config = {     
              headers: { 'content-type': 'multipart/form-data' }
          }
    
        
         //call api to save the form  

         
          try{
          const response= await marksentryapi.post('/uploadMarkfoil',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
          //setRegistrationForm(response.data.registrationForm);
          //alert(JSON.stringify(response.data));
           setUploadStatus(response.data);
          setImages([]);
          await fetchAT();
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await marksentryapi.post('/uploadMarkfoil',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 // setRegistrationForm(response.data.registrationForm); 
                     //alert(JSON.stringify(response.data));
                     setUploadStatus(response.data);
                  setImages([]);
                  await fetchAT();
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
          finally
          {
             setIsUploading(false);
          }
        }

          function addToImageList(selectedFiles)
  {
      const newImages=[...selectedFiles];
      setImages(newImages);
        setUploadStatus(null);
        setIsConfirmed("");
  }




  const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/getAllFormFillupCourses',{session:marksEntrySession,status:'marksentry'},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setCourses(response.data.courseDetails); 
         setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPositionme");
  
          if (mainElement && scrollPosition) {
              mainElement.scrollTo({
      top: parseInt(scrollPosition, 10),
      behavior: 'smooth'  // 👈 this makes it smooth
    }); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100);
        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/getAllFormFillupCourses',{session:marksEntrySession,status:'marksentry'},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data.courseDetails); 
                         setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPositionme");
  
          if (mainElement && scrollPosition) {
              mainElement.scrollTo({
      top: parseInt(scrollPosition, 10),
      behavior: 'smooth'  // 👈 this makes it smooth
    }); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100);
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
  useEffect(()=>{
  
    fetchAT();
  },[marksEntrySession]);
  
  
  const handleGoBack = () => {
    navigate(`/`); 
  };
   
  const filteredCourses = (courses || [])
  .filter(course => marksEntryLevel === "" || course.level === marksEntryLevel)
  .filter(course => marksEntrySem === "" || course.semester == marksEntrySem)
  .filter(course => marksEntrySub === "" || course.code.startsWith(marksEntrySub));
  
    return (
      <main className="w-full">

        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">MARKS ENTRY COURSES</h1>
            <p className="w-full text-center text-xs text-gray-500 text-transparent">{courses.length} <span>pending courses</span></p>     
          </div>

          <div className="flex flex-col items-center text-center mb-4">
            <p className="text-center">Select Exam session</p>
            <select
        value={marksEntrySession}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>


{marksEntrySession && marksEntrySession!="" && (<div className="w-full flex flex-col justify-center items-center gap-1 bg-blue-100 mb-4 p-4">
  <form className='w-[98%] max-w-[600px] ' onSubmit={handleAddNew}>
<div className="w-full flex flex-col justify-center items-center">
  <p className="text-center p-1 m-1">
    Upload PHD Markfoil CSV file
  </p>
 <a
  href="/sampleCSVmarkfoilToUpload.csv"
  download
  className="inline-block m-3 px-4 py-2 text-blue-700 rounded hover:text-blue-900 transition-colors duration-200"
>
  download sample CSV file to know the format
</a>


</div>
 <div className="flex flex-col justify-center items-center w-full  max-w-[600px] w-[99%] mb-2 ">
          <label
  htmlFor="fuPhotos"
  className="text-center inline-block px-4 py-2 bg-blue-600 text-white rounded cursor-pointer hover:bg-blue-700 transition"
>
  Select CSV to Upload
</label>
<input
  type="file"
  id="fuPhotos"
  name="uploadedPhotos"
  accept=".csv"
  style={{ display: 'none' }}
  onClick={(e) => {
    e.target.value = null; // 👈 reset input so same file can be selected again
  }}
  onChange={(e) => {
    addToImageList(e.target.files);
  }}
/>

</div>

<div className="max-w-[600px] w-[99%] p-3  mt-2 mb-2">
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
            </div>

  {true &&(<div className="w-full flex flex-col justify-center items-center">
    <button
          type="submit"
          className="inline-block px-4 py-2 bg-green-600 text-white rounded cursor-pointer hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isUploading  || images.length === 0}
         >
          {isUploading ? "PLEASE WAIT..." : "UPLOAD"}
    </button>
  </div>)}
    </form>
   
    {uploadStatus && uploadStatus.success  && (<div className="">
      <p className="text-center m-2 p-1">UPLOADED SUCCESSFULLY!</p>
          {uploadStatus?.data && (
  <>
    <p>Courses imported: {uploadStatus.data.courses}</p>
    <p>Students imported: {uploadStatus.data.students}</p>
    <p>Student–Course records: {uploadStatus.data.studentCourses}</p>
    <p>Batches created: {uploadStatus.data.batches}</p>
    <p>Duplicate student–course skipped: {uploadStatus.data.duplicateStudentCourseErrors}</p>
  </>
)}

    </div>)}

   {uploadStatus && !uploadStatus.success && (
  <div className="">
    {uploadStatus.errors?.map((err, index) => (
      <p
        key={index}
        className="text-red-600 text-sm m-1 p-1"
      >
        {err}
      </p>
    ))}

    <p className="text-center m-2 p-1">
     Please re-upload corrected file!
    </p>
  </div>
)}

     <div className="flex justify-between p-1 text-xs m-2">
  {isConfirmed === "UPLOADED SUCCESSFULLY." && (
    <div className="flex flex-col">
      {messages.map((msg, index) => (
        <p key={index}>{msg}</p>
      ))}
    </div>
  )}
</div>
</div>)}

        <div className="flex flex-col justify-center items-center w-full">
  {isAppLoaded ? (
    courses.length > 0 ? (
      <>
        {/* This is the div that shows before the course list */}
        <div className="w-full border-b  grid grid-cols-[1fr_1fr_1fr] gap-1 p-1 text-center bg-gray-300">
          <div className="w-full flex flex-col justify-center items-center p-2">
            <label>LEVEL</label>
          
           <select
        value={marksEntryLevel}
        onChange={(e) => levelChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
      >
        <option value="">-- Choose a Level --</option>
        {levels.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>

          </div>


           <div className="w-full flex flex-col justify-center items-center p-2">
            <label>SEMESTER</label>
          
           <select
        value={marksEntrySem}
        onChange={(e) => semesterChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
      >
        <option value="">-- Choose a Sem --</option>
        {semesters.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>

          </div>
<div className="w-full flex flex-col justify-center items-center p-2">
            <label>DEPT CODE</label>
          <input
 value={marksEntrySub}
        onChange={(e) => subChanged(e)}
        className="p-2 rounded border-b-2 border-b-gray-600 w-full bg-transparent outline-none"
        placeholder="E.g. ZOO BEN ASM ..."
          />
          

          </div>
          
        </div>
    <div className="flex flex-col items-center justify-center">
       
       <p className="text-center  p-1 m-2"><span className="font-bold">{filteredCourses.length} </span> courses match your filter</p>
         <div className="flex flex-wrap justify-center items-start gap-4 w-full min-h-[500px] p-2 mt-4">
{filteredCourses.map(course => (
  <Course key={course.code} course={course} session={marksEntrySession} />
))}</div></div>
      </>
    ) : (
      <p>No courses available.</p>
    )
  ) : (
    <p>Please wait...</p>
  )}
</div>

        </div>

     
      </main>
    )
  }
  
  export default MarksEntry